import { Email_New } from '~/graphql/types';
import { NamedEmail } from '~/util/namedEmailFormatter';

const convertNamedEmailToEmailNew = (namedEmail: NamedEmail): Email_New => ({
  name: namedEmail.name || null,
  email: namedEmail.email,
});

export default convertNamedEmailToEmailNew;
